import { connect } from 'react-redux'
import { selectDeviceTypeIsMobile } from 'selectors/app'
import { selectModalProps } from 'selectors/modals'
import Modal from './view'

const select = state => ({
  deviceTypeIsMobile: selectDeviceTypeIsMobile(state),
  modalProps: selectModalProps(state),
})

export default connect(select, null, null, { forwardRef: true })(Modal)
